import { takeEvery } from "starfx";

import { schema } from "../schema";
import { xThunk } from "../xapis";

import type { ThunkCtx, Next } from "starfx";

// maingrid.tsx
export const setInvoiceGridPersistence = xThunk.create<unknown>(
  "/thks/react/setIvTrackGridPersistor",
  { supervisor: takeEvery },
  function* (ctx: ThunkCtx, next: Next) {
    yield* schema.update([schema.uiPersistInvoiceGrid.set(ctx.payload)]);
    yield* next();
  }
);

// spvList.tsx
export const setSpvListPersistence = xThunk.create<unknown>(
  "/thks/react/setSpvListPersistor",
  { supervisor: takeEvery },
  function* (ctx: ThunkCtx, next: Next) {
    yield* schema.update([schema.uiPersistSpvList.set(ctx.payload)]);
    yield* next();
  }
);
